export const catalogs = (state) => state.catalogs
export const taxLosses = (state) => state.tax_losses
export const taxLoss = (state) => state.tax_loss
